import { useCallback } from 'react';
import { push } from 'redux-first-history';
import { trimEnd, trimStart } from 'lodash-es';
import { useDispatch } from '@s20/hooks/redux.hooks';
import { setPermissions } from '@s20/slices/features/permissions.slice';
import { setTenant, setTenantSettings, setTenantTheme } from '@s20/slices/features/common.slice';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../Common';

const defaultUrl = '/';

export const useSwitchTenant = (destinationUrl = defaultUrl) => {
    const dispatch = useDispatch();

    const handleTenantSwitch = useCallback((tenantId) => async () => {
        try {
            const response = await httpClient.put(ApiRoutes.auth.updateTenant(tenantId), {}, httpClient.format.json);

            if (response) {
                dispatch(setPermissions(response.permissions ?? []));

                dispatch(setTenant({
                    id: response.id,
                    companyName: response.companyName,
                    countryId: response.countryId,
                    countryCode: response.countryCode,
                    defaultCurrencyCode: response.defaultCurrencyCode,
                    tenantSettings: response.tenantSettings,
                }));

                dispatch(setTenantSettings(response?.tenantSettings));
                dispatch(setTenantTheme(response?.tenantSettings?.defaultTheme));

                sessionStorage.setItem('currentTenantId', tenantId);

                const baseUrl = trimEnd(response.baseUrl, '/');

                if (typeof baseUrl === 'string' && baseUrl && baseUrl !== '/') {
                    const dest = `${baseUrl}/${trimStart(destinationUrl, '/')}`;
                    const impersonatingToken = window.sessionStorage.getItem('impersonating');
                    const destUrl = impersonatingToken
                        ? `${dest}${dest.includes('?') ? '&' : '?'}impersonating=${encodeURIComponent(impersonatingToken)}`
                        : dest;
                    window.location.href = destUrl;
                } else {
                    dispatch(push(`/${trimStart(destinationUrl, '/')}`));
                }
            } else {
                console.error(response);

                // Something happened, so let's try hard refreshing
                window.location.href = '/';
            }
        } catch (e) {
            console.error(e);

            // Something happened, so let's try hard refreshing
            window.location.href = '/';
        }
    }, []);

    return handleTenantSwitch;
};